import Vue from 'vue'
import Vuex from 'vuex'
import { getCustomer, setCustomer, clearCustomer, isLogin } from '@/utils/auth'
import { post } from '@/utils/request'
import { customerLogout } from '@/api/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用户信息
    customer: getCustomer(),
    // 是否登录
    isLogin: isLogin(),
    // 未读消息数
    messageCount: 0,
    // 未登录提示弹窗
    loginTipVisible: false
  },

  mutations: {
    SET_CUSTOMER (state, customer) {
      state.customer = customer
      state.isLogin = !!(customer && customer.id)
    },
    SET_MESSAGE_COUNT (state, count) {
      state.messageCount = count
    },
    SET_LOGIN_TIP (state, visible) {
      state.loginTipVisible = visible
    },
    LOGOUT (state) {
      state.customer = null
      state.isLogin = false
      state.messageCount = 0
    }
  },

  actions: {
    /**
     * 登录成功后保存用户信息
     */
    login ({ commit }, { customer, rememberMe }) {
      setCustomer(customer, rememberMe)
      commit('SET_CUSTOMER', customer)
    },

    /**
     * 退出登录（先走接口，再清除本地状态）
     */
    async logout ({ commit }) {
      try {
        // token 仍在，由请求拦截器自动放入 header
        await customerLogout()
      } catch (e) {
        // 接口失败也不阻断本地退出
      }
      clearCustomer()
      commit('LOGOUT')
    },

    /**
     * 更新用户信息（如编辑资料后）
     */
    updateCustomer ({ commit, state }, customer) {
      const rememberMe = localStorage.getItem('cms_remember_me') === '1'
      setCustomer(customer, rememberMe)
      commit('SET_CUSTOMER', customer)
    },

    /**
     * 获取未读消息数
     */
    async fetchMessageCount ({ commit, state }) {
      if (!state.isLogin || !state.customer) return
      try {
        const res = await post('cmsCustomer/findMyMsg', {
          // recipient: state.customer.id,
          msgStatus: 0
        })
        if (res.code === '00000') {
          // data 为 null/空时按 0 计，保证最后一条确认后角标能清零
          commit('SET_MESSAGE_COUNT', (res.data && res.data.length) || 0)
        }
      } catch (e) {
        // 静默失败
      }
    }
  },

  getters: {
    customer: state => state.customer,
    isLogin: state => state.isLogin,
    messageCount: state => state.messageCount,
    customerName: state => state.customer ? state.customer.username : ''
  }
})
